import { Redirect, Route, RouteProps } from "react-router-dom";

import ApiInstance from "util/Api";

export const PublicRoute = (props: RouteProps) => {
  if (ApiInstance.authToken) return <Redirect to="/upload" />;
  return <Route {...props} />;
};
